import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { isStorefrontFoundationEnabled } from "./Components/Storefront/featureFlags";

export const isSameVariantRoute = (previous = "", current = "") => {
  const before = previous.match(/^\/product\/([^/]+)\/([^/]+)\/([^/]+)\/?$/);
  const after = current.match(/^\/product\/([^/]+)\/([^/]+)\/([^/]+)\/?$/);
  return Boolean(before && after && before[1] === after[1] && before[2] === after[2]);
};

export function debounce(fn, wait) {
  let timer = null;
  return function (...params) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...params);
    }, wait);
  };
}

export const pathMap = new Map();

const Index = () => {
  const { pathname } = useLocation();
  const previousPath = useRef(null);
  const v2 = useSelector(state => isStorefrontFoundationEnabled(state.store?.store?.settings));

  useEffect(() => {
    const preserveScroll = v2 && isSameVariantRoute(previousPath.current || "", pathname);
    previousPath.current = pathname;
    if (preserveScroll) {
      pathMap.set(pathname, window.scrollY);
      return;
    }
    if (pathMap.has(pathname)) {
      window.scrollTo(0, pathMap.get(pathname));
    } else {
      pathMap.set(pathname, 0);
      window.scrollTo(0, 0);
    }
  }, [pathname, v2]);

  useEffect(() => {
    const fn = debounce(() => {
      pathMap.set(pathname, window.scrollY);
    }, 200);

    window.addEventListener("scroll", fn);
    return () => window.removeEventListener("scroll", fn);
  }, [pathname]);

  return null;
};

export default Index;
